import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowBottomRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16.95 16.95-9.9-9.9M16.95 9.877v7.073l-7.072-.001"
    />
  </svg>
);
export default SvgArrowBottomRight;
